import { Injectable } from '@angular/core';
import { BaseAPIClass } from '../class/baseAPI.class';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class VisitasService extends BaseAPIClass {
  baseUrl = '';

  constructor(protected httpClient: HttpClient) {
    super(httpClient);
    this.baseUrl = this.baseUrl + '/visitas';
  }

  visitasCliente(visitado: any, term: any, date: any): Observable<any> {
    return this.httpClient.get(
      this.baseUrl +
        '/proximas?visitado=' +
        visitado +
        '&term=' +
        term +
        '&fecha=' +
        date
    );
  }
  verPDF(): Observable<any> {
    return this.httpClient.get(this.baseUrl + '/proximas-pdf', {
      responseType: 'blob'
    });
  }

  marcarVisitado(id: any): Observable<any> {
    return this.httpClient.get(this.baseUrl + '/marcar/' + id);
  }
}
